var getElementName = function getElementName(element) {
  var _a, _b;

  var elementName = ((_a = element === null || element === void 0 ? void 0 : element.target) === null || _a === void 0 ? void 0 : _a.displayName) || ((_b = element === null || element === void 0 ? void 0 : element.type) === null || _b === void 0 ? void 0 : _b.displayName) || (element === null || element === void 0 ? void 0 : element.type);
  return typeof elementName === 'string' ? elementName : null;
};

export default getElementName;